class UserAddressController {
    static $inject = ["stToast"];

    constructor(stToast) {
        this.toast = stToast;
    }

    $onInit() {
    }
}

angular
    .module("app")
    .component("userAddress", { // user-address
        bindings: {
            user: "<"
        },
        templateUrl: "src/app/_shared/userAddress/userAddress.html",
        controller: UserAddressController
    });
